// extracted by mini-css-extract-plugin
export default {"EditBranch__Field--normal":"EditBranch_EditBranch__Field--normal__xi9uW","EditBranch__Field--spaced":"EditBranch_EditBranch__Field--spaced__E5UhL"};